import { render, staticRenderFns } from "./PerformancePage.vue?vue&type=template&id=d98f3032&scoped=true&"
import script from "./PerformancePage.vue?vue&type=script&lang=js&"
export * from "./PerformancePage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=d98f3032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98f3032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VLayout,VMain})
